import { useState, useEffect } from "react";
import { notification } from "antd";

import Header from "../../components/Header/Header";
import Footer from "../../components/Footer/Footer";
import Button from "../../components/Button/Button";
import SubjectCard from "../../components/SubjectCard/SubjectCard";
import Carousel from "react-multi-carousel";

import { getSubjects } from "../../services/learnService";

import { useNavigate } from "react-router";
const SelectSchool = () => {
  const navigate = useNavigate();

  const [selectedSubjects, setSelectedSubjects] = useState([]);
  const [loading, setLoading] = useState(false);
  const [subjects, setSubjects] = useState([]);

  const responsive = {
    superLargeDesktop: {
      // the naming can be any, depends on you.
      breakpoint: { max: 4000, min: 3000 },
      items: 5,
    },
    desktop: {
      breakpoint: { max: 3000, min: 1024 },
      items: 3,
    },
    tablet: {
      breakpoint: { max: 1024, min: 464 },
      items: 2,
      paritialVisibilityGutter: 60,
    },
    mobile: {
      breakpoint: { max: 464, min: 0 },
      items: 1,
      paritialVisibilityGutter: 60,
    },
  };

  useEffect(() => {
    const getAllSubjects = async () => {
      setLoading(true);
      try {
        let res = await getSubjects();
        setSubjects(res.data.subjects);
        setLoading(false);
      } catch (error) {
        setLoading(false);
        notification["error"]({
          message: "An error occured, please refresh",
        });
        setLoading(false);
      }
    };
    getAllSubjects();
  }, []);

  return (
    <div>
      <Header />
      <div className="select-school-hero">
        <h1>Learn from A- list tutors</h1>
        <p>
          Top schools and tutors have partnered with PL by Edves to <br />{" "}
          ensure learners like you have easy access to quality educational
          learning resources
        </p>
      </div>
      <div className="recommended-section">
        <>
          <div className="recommended-section__title">
            <h2> Subjects recommended just for you</h2>
            <p>Select a school you would like to learn from</p>
          </div>
          <Carousel
            responsive={responsive}
            showDots={true}
            itemClass={`carouselItem`}
          >
            {subjects === undefined ? (
              <div></div>
            ) : (
              subjects.map((el) => (
                <SubjectCard
                  key={el.id}
                  id={el.id}
                  subject={el.name}
                  description={el.description}
                  subjectHeader={el.banner}
                  selectedSubjects={selectedSubjects}
                  selectSubject={() => {
                    selectedSubjects.includes(el.id)
                      ? setSelectedSubjects(
                          selectedSubjects.filter(function (val) {
                            return val !== el.id;
                          })
                        )
                      : setSelectedSubjects([...selectedSubjects, el.id]);
                  }}
                />
              ))
            )}
          </Carousel>
        </>
        <div style={{ marginTop: "84px" }}>
          <Button
            text="Save Subject and Continue"
            className="primary-btn"
            width="100%"
            disabled={selectedSubjects.length === 0}
            onClick={() => {
              localStorage.setItem(
                "subjects",
                JSON.stringify(selectedSubjects)
              );
              navigate("/student-signup");
            }}
          />
        </div>
      </div>

      <Footer />
    </div>
  );
};

export default SelectSchool;
